import { IStorageService } from "@core/storage";
import { IAnonymousPageObjectTreeService, PageCacheKey } from "@modules/basic/page";
import { AnonymousPageObjectTreeService } from "@modules/basic/page/anonymous/anonymous-page-object-tree.service";
import { ProductData } from "@modules/product/model/domain/data/ProductData";
import { PropertyModel } from "@modules/property-model/model/domain/PropertyModel";
import { IServiceProvider } from "angular";
import { StoreProductObjectTreeService } from "../../store-product/store-product-object-tree.service";

/*
 * @Author: Roman
 * @Date: 2022-12-08 19:30:58
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-12-14 15:09:12
 * @FilePath: \qpmn-site\src\app\pages\products\detail\product-detail-object-tree.ts
 * @Description: 
 */

export class ProductDetailObjectTree extends AnonymousPageObjectTreeService {
    public static readonly $inject: Array<string> = ["storageService"];
    public currentProductId: number | undefined;
    public currentProductData: ProductData
    public configurableProductId: number | undefined;
    public symbol: string | undefined;
    public currentPropertyDomain: PropertyModel;
    public propertyDomain: PropertyModel;
    /**
     * @deprecated
     */
    public activeProfileId: number;
    public productImages: Array<any>;
    public productName: string;
    public storePlatformTypes: Array<any>;
    constructor(
        public storageService: IStorageService<PageCacheKey>
    ) {
        super();

    }
}

